export default __webpack_public_path__ + "static/media/001-fire.7bfd747e.png";